import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { FileCard } from "@/components/FileCard";
import { Loader2, Users2, Building2, ChevronRight } from "lucide-react";

export default function EntityDetail() {
  const { id } = useParams();
  const [c, setC] = useState(null);
  useEffect(() => { setC(null); api.get(`/entities/${id}`).then((r) => setC(r.data)).catch(() => {}); }, [id]);

  if (!c) return <div className="flex justify-center h-96 items-center text-slate-500"><Loader2 className="w-6 h-6 animate-spin" /></div>;
  const isPerson = c.type === "person";
  const Icon = isPerson ? Users2 : Building2;

  return (
    <div className="space-y-8">
      <nav className="flex items-center gap-1.5 text-sm text-slate-500">
        <Link to={isPerson ? "/people" : "/organizations"} className="hover:text-white">{isPerson ? "People" : "Organizations"}</Link>
        <ChevronRight className="w-3.5 h-3.5" /><span className="text-slate-300">{c.name}</span>
      </nav>
      <div className="flex items-center gap-5">
        <div className="w-16 h-16 rounded-full bg-blue-600/15 flex items-center justify-center"><Icon className="w-8 h-8 text-blue-400" strokeWidth={1.5} /></div>
        <div>
          <div className="text-[11px] uppercase tracking-widest text-blue-400">{c.type}</div>
          <h1 className="font-display font-extrabold text-3xl text-white tracking-tight">{c.name}</h1>
          <div className="text-sm text-slate-500 mt-1">{c.file_count} associated file(s)</div>
        </div>
      </div>
      {c.files?.length > 0 ? (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">{c.files.map((f, i) => <FileCard key={f.id} f={f} index={i} />)}</div>
      ) : <p className="text-slate-600 text-sm">No associated files.</p>}
    </div>
  );
}
